export enum LogoutCause {
  UserInitiated = 'user_initiated',
}
